import { createMuiTheme } from "@material-ui/core";
export var muiTheme = createMuiTheme({
  typography: {
    fontFamily: "Avenir Next, sans-serif;"
  }
});
export var palette = {
  white: "#FFF",
  grayLight: "#EEEEEE",
  gray60: "#999",
  gray70: "#666",
  pink: "#FFDFDF",
  black: "#000000",
  black2: "#333"
};
export var arrowGenerator = function arrowGenerator() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#fff";
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.95em",
      width: "2em",
      height: "1em",
      boxShadow: "-2px -2px 5px rgba(0,0,0,0.06)",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: "transparent transparent " + color + " transparent"
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.95em",
      width: "2em",
      height: "1em",
      boxShadow: "3px 3px 7px rgba(0,0,0,0.07)",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: color + " transparent transparent transparent"
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.95em",
      height: "2em",
      width: "1em",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: "transparent " + color + " transparent transparent"
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: "-0.95em",
      height: "2em",
      width: "1em",
      boxShadow: "3px -3px 7px rgba(0,0,0,0.07)",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: "transparent transparent transparent " + color
      }
    }
  };
};
export var commonArrowStyles = {
  position: "absolute",
  fontSize: 6,
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: 0,
    height: 0,
    borderStyle: "solid"
  }
};